interface GetNpcFbaFreightAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT;
  payload: any;
}

interface GetNpcFbaFreightParamsAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_PARAMS;
  payload: any;
}

interface GetNpcFbaFreightTotalAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TOTAL;
  payload: any;
}

interface GetNpcFbaFreightBrandAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_BRAND;
  payload: any;
}

interface GetNpcFbaFreightTransactionAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TRANSACTION;
  payload: any;
}

interface GetNpcFbaFreightMinDateAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_MINDATE;
  payload: string;
}

interface SetNpcFbaFreightLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_LOADING;
}

interface SetNpcFbaFreightTotalLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TOTAL_LOADING;
}

interface SetNpcFbaFreightBrandLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_BRAND_LOADING;
}

interface SetNpcFbaFreightTransactionLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TRANSACTION_LOADING;
}

interface ClearNpcFbaFreightAction {
  type: NpcFbaFreightActionTypes.CLEAR_NPC_FBA_FREIGHT;
}

interface UpdateNpcFbaFreightTransactionAction {
  type: NpcFbaFreightActionTypes.UPDATE_NPC_FBA_FREIGHT_TRANSACTION;
  payload: any;
}

interface GetNpcFbaFreightAnalyticsAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS;
  payload: any;
}
interface GetNpcFbaFreightAnalyticsChartAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS_CHART;
  payload: any;
}
interface SetNpcFbaFreightAnalyticsLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING;
  payload: any;
}
interface SetNpcFbaFreightAnalyticsChartLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING;
  payload: any;
}
interface GetNpcFbaFreightInboundFeeAction {
  type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_INBOUND_FEE;
  payload: any;
}
interface SetNpcFbaFreightInboundFeeLoadingAction {
  type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING;
}

export enum NpcFbaFreightActionTypes {
  GET_NPC_FBA_FREIGHT = 'GET_NPC_FBA_FREIGHT',
  GET_NPC_FBA_FREIGHT_PARAMS = 'GET_NPC_FBA_FREIGHT_PARAMS',
  GET_NPC_FBA_FREIGHT_TOTAL = 'GET_NPC_FBA_FREIGHT_TOTAL',
  GET_NPC_FBA_FREIGHT_BRAND = 'GET_NPC_FBA_FREIGHT_BRAND',
  GET_NPC_FBA_FREIGHT_TRANSACTION = 'GET_NPC_FBA_FREIGHT_TRANSACTION',
  GET_NPC_FBA_FREIGHT_MINDATE = 'GET_NPC_FBA_FREIGHT_MINDATE',
  SET_NPC_FBA_FREIGHT_LOADING = 'SET_NPC_FBA_FREIGHT_LOADING',
  SET_NPC_FBA_FREIGHT_TOTAL_LOADING = 'SET_NPC_FBA_FREIGHT_TOTAL_LOADING',
  SET_NPC_FBA_FREIGHT_BRAND_LOADING = 'SET_NPC_FBA_FREIGHT_BRAND_LOADING',
  SET_NPC_FBA_FREIGHT_TRANSACTION_LOADING = 'SET_NPC_FBA_FREIGHT_TRANSACTION_LOADING',
  UPDATE_NPC_FBA_FREIGHT_TRANSACTION = 'UPDATE_NPC_FBA_FREIGHT_TRANSACTION',
  GET_NPC_FBA_FREIGHT_ANALYTICS = 'GET_NPC_FBA_FREIGHT_ANALYTICS',
  GET_NPC_FBA_FREIGHT_ANALYTICS_CHART = 'GET_NPC_FBA_FREIGHT_ANALYTICS_CHART',
  SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING = 'SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING',
  SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING = 'SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING',
  GET_NPC_FBA_FREIGHT_INBOUND_FEE = 'GET_NPC_FBA_FREIGHT_INBOUND_FEE',
  SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING = 'SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING',
  CLEAR_NPC_FBA_FREIGHT = 'CLEAR_NPC_FBA_FREIGHT'
}

export interface NpcFbaFreightState {
  chart: any[];
  table: any[];
  total: {
    totalQty: number;
    totalAmount: number;
    averageAmount: number;
  };
  lists: {
    brands: any[];
    categories: any[];
    sizes: any[];
    productTypes: any[];
    inboundSizes: any[];
    inboundPlacements: any[];
  };
  brand: {
    table: any[];
    items_table: any[];
  };
  transaction: {
    table: any[];
    totalAmount: number;
    averageAmount: number;
  };
  analytics: {
    totalShippedQty: number;
    toQty: number;
    totalShippingCost: number;
    averageShippingCost: number;
    averagePerItem: number;
    transfers: [];
    toLines: [];
  };
  analytics_charts: {
    categoryChart: [];
    packageChart: [];
    totalCategory: {};
    categories: [];
    packages: [];
  };
  inbound_fee: {
    total: {
      fee: number;
      quantity: number;
      average: number;
    };
    chartAverage: any[];
    chartQty: any[];
    details: {
      [key: string]: string;
    };
    itemsTable: any[];
    transactionsTable: any[];
  };
  min_date: string | null;
  loading_lists: boolean;
  loading_brand: boolean;
  loading_transaction: boolean;
  loading_freight: boolean;
  loading_freight_total: boolean;
  loading_analytics: boolean;
  loading_analytics_charts: boolean;
  loading_inbound_fee: boolean;
}

export type NpcFbaFreightAction =
  | ClearNpcFbaFreightAction
  | GetNpcFbaFreightAction
  | GetNpcFbaFreightParamsAction
  | GetNpcFbaFreightTotalAction
  | GetNpcFbaFreightBrandAction
  | GetNpcFbaFreightTransactionAction
  | SetNpcFbaFreightLoadingAction
  | SetNpcFbaFreightTotalLoadingAction
  | SetNpcFbaFreightBrandLoadingAction
  | SetNpcFbaFreightTransactionLoadingAction
  | GetNpcFbaFreightMinDateAction
  | UpdateNpcFbaFreightTransactionAction
  | GetNpcFbaFreightAnalyticsAction
  | GetNpcFbaFreightAnalyticsChartAction
  | SetNpcFbaFreightAnalyticsLoadingAction
  | SetNpcFbaFreightAnalyticsChartLoadingAction
  | GetNpcFbaFreightInboundFeeAction
  | SetNpcFbaFreightInboundFeeLoadingAction;
